export { default as DeviceProvider, DeviceContext } from './DeviceContext';
